import styled, {createGlobalStyle} from 'styled-components'
import Settings from '../../Settings'

export const InputRangeStyle = createGlobalStyle`
.input-range__slider {
  appearance: none;
  background: #fff;
  border: none;
  border-radius: 100%;
  cursor: pointer;
  display: block;
  height: 1.4vw;
  width: 1.4vw;
  margin-left: -.5vw;
  margin-top: -1.9vw;
  outline: none;
  position: absolute;
  top: 1vw;
  transition: transform .1s ease-out;
  
  &:hover {
    background: ${Settings.themeColor};
  }
}

.input-range__slider:active {
  transform: scale(1.3);
}

.input-range__slider-container {
  transition: left .1s ease-out;
}

.input-range__label {
  display: none
}

.input-range__label-container {
  display: none;
}

.input-range__track {
  background: #eeeeee;
  cursor: pointer;
  display: block;
  height: .4vw;
  position: relative;
  border-radius: .2vw;
  transition: left .1s ease-out, width .1s ease-out;
}

.input-range__track--background {
  left: 0;
  margin-top: -.2vw;
  position: absolute;
  right: 0;
  top: 50%;
}

.input-range__track--active {
  background: ${Settings.themeColor};
}

.input-range {
  height: 3vw;
  position: relative;
  width: 100%;
}
`

export const Controls = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 5vw;
  padding-top: 1vw;
  padding-bottom: 1vw;
  background-color: rgba(0, 0, 0, 0.25);
`

export const Button = styled.div`
  width: 3vw;
  height: 3vw;
  position: relative;
  float: left;
  cursor: pointer;
  margin-left: 1vw;
  color: #fff;

  &:hover {
    color: ${Settings.themeColor};

    > * {
      border-left-color: ${Settings.themeColor};
    }
  }
`

export const SeekContainer = styled.div`
  width: 90vw;
  height: 3vw;
  position: relative;
  float: left;
  margin-left: 1vw;
  margin-right: 1vw;
`

export const PlayButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0;
  height: 0;
  border-width: 1vw 0 1vw 1.6vw;
  border-style: solid;
  border-top-color: transparent;
  border-bottom-color: transparent;
  border-left-color: #fff;
`

export const PauseButton = styled.div`
  position: absolute;
  top: 50%;
  left: calc(50% - 0.6vw);
  transform: translate(-50%, -50%);
  width: 0.6vw;
  height: 2vw;
  box-shadow: inset 0 0 0 3.2vw, 1.2vw 0 0 0;
`

export const StopButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0;
  height: 0;
  border: solid 1vw;
`
